import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import * as Glob from "src/Globale";
import { Trad } from "src/components/";
import { _PageWrapper } from "../layout";

const useStyles = makeStyles(({ spacing }: Theme) => ({
    content: { minHeight: "calc(100vh - 50px)" },
    mainContent: {
        padding: spacing(12, 0),
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    message: {
        marginTop: "30px"
    }
}));

export const _AccessError: React.FC<Glob.IRouteGlobaleProps> = props => {
    const classes = useStyles();

    return (
        <_PageWrapper {...props}>
            <main>
                <Paper className={classes.content}>
                    <Container component="main" maxWidth="sm">
                        <div className={classes.mainContent}>
                            <Typography component="h4" variant="h3" color="error">
                                <ErrorOutlineIcon fontSize="inherit" />
                            </Typography>{" "}
                            <Typography component="h2" variant="h4" color="error">
                                {Trad.Trad("Errore")}
                            </Typography>
                            <Typography component="h3" variant="h5" color="primary" className={classes.message}>
                                {Trad.Trad("Non hai i permessi per accedere alla pagina")}
                            </Typography>
                        </div>
                    </Container>
                </Paper>
            </main>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/AccessError.tsx